<!--
 * @Author: 张天昊
 * @Date: 2024-05-24 15:19:50
 * @LastEditTime: 2026-04-16 15:49:02
 * @LastEditors: rossdong rossdong@yntengyun.com
 * @Description: 
 * @FilePath: /Mobile/src/pages/itineraryUniversal/tourists.vue
-->
<script>
import { computed, defineComponent, nextTick, ref, watch } from 'vue';
import { TouristAgeTypes, CertificateTypes } from './constants';
import PrivacyCheckButton from './components/PrivacyCheckButton.vue';
import TouristNameTableCell from './components/TouristNameTableCell.vue';
import { transformEnumValue2Label, genEmptyTextPlaceholder } from './utils';
import { useAuth } from './composables/useAuth';
import { Table } from '@/components/Table';
import store from '@/store';
import router from '@/router/routers';

export default defineComponent({
  components: {
    Table,
    PrivacyCheckButton,
    TouristNameTableCell
  },
  setup() {
    const range = router.currentRoute.query.range; // 游客范围，实际上是文本标题

    const CertificateTypesValue2Label =
      transformEnumValue2Label(CertificateTypes);

    const { privacyApplyButtonAuth } = useAuth();

    // 待展示游客
    const touristsInView = computed(
      () => store.state.itineraryUniversal.touristsInView
    );
    // 激活的游客
    const enableTouristsInView = computed(() =>
      store.state.itineraryUniversal.touristsInView.filter(
        (item) => !item.disabled
      )
    );
    // 统计
    const counter = computed(() => {
      const len = enableTouristsInView.value.length;
      if (len === 0) {
        return {
          成人: [0, 0],
          儿童: [0, 0],
          老人: [0, 0]
        };
      }
      const c1 = enableTouristsInView.value.filter(
        (item) => item.ageType === TouristAgeTypes.成人
      ).length;
      const c2 = enableTouristsInView.value.filter(
        (item) => item.ageType === TouristAgeTypes.儿童
      ).length;
      const c3 = enableTouristsInView.value.filter(
        (item) => item.ageType === TouristAgeTypes.老人
      ).length;
      const formatter = (number) =>
        Number.isInteger(number) ? number : number.toFixed(1);
      return {
        成人: [c1, formatter((c1 / len) * 100)],
        儿童: [c2, formatter((c2 / len) * 100)],
        老人: [c3, formatter((c3 / len) * 100)]
      };
    });

    const tableColumns = [
      {
        dataProp: 'name',
        title: '姓名',
        minWidth: '102px',
        fixed: 'left',
        renderCell(h, { rowData }) {
          return h(TouristNameTableCell, { props: { data: rowData } });
        }
      },
      {
        dataProp: 'health',
        title: '健康状态',
        minWidth: '102px',
        renderCell(h, { rowData }) {
          return genEmptyTextPlaceholder(rowData.health);
        }
      },
      {
        dataProp: 'certiCodeType',
        title: '证件类型',
        minWidth: '118px',
        renderCell(h, { rowData }) {
          if (rowData.certiCodeType === CertificateTypes.残疾证) {
            return h('span', { style: { color: '#F46453' } }, '残疾证');
          }
          return rowData.certiCodeType
            ? CertificateTypesValue2Label[`${rowData.certiCodeType}`]
            : genEmptyTextPlaceholder();
        }
      },
      {
        dataProp: 'certiNo',
        title: '证件号码',
        minWidth: '168px',
        renderCell(h, { rowData }) {
          return genEmptyTextPlaceholder(rowData.certiNo);
        }
      },
      {
        dataProp: 'phone',
        title: '联系电话',
        minWidth: '122px',
        renderCell(h, { rowData }) {
          return genEmptyTextPlaceholder(rowData.phone);
        }
      },
      {
        dataProp: 'originTrip',
        title: '客源地',
        minWidth: '118px',
        renderCell(h, { rowData }) {
          if (!rowData.originTrip) {
            return genEmptyTextPlaceholder();
          }
          const [p, c] = rowData.originTrip.split('/');
          return h('div', {}, [h('div', {}, p), h('div', {}, c)]);
        }
      },
      {
        dataProp: 'tourPrice',
        title: '参团价格',
        minWidth: '102px',
        renderCell(h, { rowData }) {
          if (!rowData.tourPrice) {
            return genEmptyTextPlaceholder()
          }
          return `${rowData.tourPrice}元`;
        }
      },
      {
        dataProp: 'insuranceStatus',
        title: '保险购买状态',
        minWidth: '120px',
        renderCell(h, { rowData }) {
          // if (!rowData.insuranceStatus) {
          //   return genEmptyTextPlaceholder();
          // }
          const mapInsuranceState = {
            0: '未购买',
            1: '部分购买',
            2: '已购买',
          }
          let stateStr = mapInsuranceState[rowData.insuranceStatus ?? 0]
          return h('div', { class: 'flex' }, [
            h('div', { class: "mr-8 flex-none" }, stateStr),
            h('div',
              {
                class: 'flex items-center',
                on: {
                  click: () => {
                    currentUserRow.value = rowData;
                    showInsuranceDetail.value = true;
                  }
                }
              }, [
              h('span', { class: "mr-2 text-[#36B374] flex-none" }, '详情'),
              h('van-icon', { props: { name: 'arrow', size: 12, color: '#1C8C5E' }, class: "flex-none" })
            ])
          ]);
        }
      },
    ];

    // 出散团信息
    const teamDate = computed(() => {
      let detailInfo = store.state.itineraryUniversal.detailInfo.value?.itineraryInfoMessage;
      return `${detailInfo.teamStartDate} 至 ${detailInfo.teamEndDate}`
    }
    );


    /** UI state */
    const tableInst = ref();
    /**
     * 给未参团的row添加disable样式
     * 但离团的标签图片要保持透明度1
     */
    function addDisabledStyle() {
      // 没有离团的row则不需要添加样式
      if (touristsInView.value.length === enableTouristsInView.value.length) {
        return;
      }
      if (tableInst.value) {
        const tableEl = tableInst.value.$el;
        const tbody = tableEl.querySelector('tbody');
        const rows = tbody.querySelectorAll('tr.o-tr');
        const targetRows = [];
        // 获取需要执灰的tr节点
        for (let i = 0; i < touristsInView.value.length; i++) {
          if (touristsInView.value[i].disabled) {
            targetRows.push(rows[i]);
          }
        }
        if (targetRows.length > 0) {
          for (const row of targetRows) {
            // 第一个单元格的文字节点
            const contentsInComplexCol = row.querySelectorAll(
              'td.o-td:first-child .content'
            );
            // 其余单元格
            const simpleCols = row.querySelectorAll(
              'td.o-td:not(:first-child)'
            );
            for (let el of contentsInComplexCol) {
              el.style.opacity = 0.5;
            }
            for (let el of simpleCols) {
              el.style.setProperty('--o-td-text-op', 0.5);
            }
          }
        }
      }
    }

    watch(
      touristsInView,
      (arr) => {
        if (arr.length > 0) {
          nextTick(() => {
            addDisabledStyle();
          });
        }
      },
      {
        immediate: true
      }
    );

    //  保险
    // 弹框显示
    const currentUserRow = ref('');
    const showInsuranceDetail = ref(false);
    const userInsuranceDetail = computed(() => {
      return store.state.itineraryUniversal.userInsuranceDetail;
    });
    watch(
      showInsuranceDetail,
      (newValue) => {
        if (newValue) {
          if (currentUserRow.value && currentUserRow.value.id !== '') {
            store.dispatch('itineraryUniversal/getUserInsuranceDetail', currentUserRow.value.id);
          }
        } else {
          store.commit('itineraryUniversal/setUserInsuranceDetail', null);
        }

      },
      {
        immediate: false
      }
    )

    return {
      range,
      tableInst,
      touristsInView,
      enableTouristsInView,
      counter,
      privacyApplyButtonAuth,
      tableColumns,
      showInsuranceDetail,
      userInsuranceDetail,
      currentUserRow,
      teamDate
    };
  }
});
</script>

<template>
  <div class="bg-board-a text-black-a">
    <div class="flex py-10 px-12 bg-white">
      <div
        class="flex-shrink-0 w-100 h-66 rounded-tl-4 rounded-bl-4 mr-1 flex flex-col items-center justify-center bg-header">
        <div class="text-14 leading-22">{{ range ? range : '游客总数' }}</div>
        <div class="text-grey-g mt-3">
          <span class="font-din text-18 leading-22 font-bold text-black-a">{{
            enableTouristsInView?.length
          }}</span>人
        </div>
      </div>
      <div class="flex-auto h-66 px-20 rounded-tr-4 rounded-br-4 bg-header flex justify-between items-center">
        <div v-for="[label, values] in Object.entries(counter)" :key="label">
          <div class="text-14 leading-22 text-black-b">{{ label }}</div>
          <div class="mt-2 text-grey-g">
            <template v-if="values[0] > 0">
              <span class="highlight-number">{{ values[0] }}</span>人<span class="highlight-number">{{ values[1]
              }}</span>%
            </template>
            <span v-else class="highlight-number">-</span>
          </div>
        </div>
      </div>
    </div>
    <div class="px-12">
      <div class="flex items-center py-16">
        <div class="flex-auto text-14 leading-20 text-black-b">
          向左滑动查看完整信息
        </div>
        <PrivacyCheckButton v-if="privacyApplyButtonAuth" />
      </div>
      <Table :columns="tableColumns" :data="touristsInView" ref="tableInst" class="custom-table" height="68vh" />
    </div>

    <!-- 保险购买详情 -->
    <van-popup v-model:show="showInsuranceDetail" position="bottom" class="rounded-tl-8 rounded-tr-8 pb-20"
      :style="{ height: '70%' }">
      <div class="flex flex-col">
        <!-- header -->
        <div class="p-20 flex items-center">
          <div class="text-black text-18 font-bold ">保险购买详情</div>
          <svg-icon pre-path="itineraryUniversal" name="ic-bottom-popup-close"
            class="absolute top-20 right-20 w-28 h-28" @click="showInsuranceDetail = false" />
        </div>

        <!-- body -->
        <div class="pr-20 pl-20">
          <div><span class="text-[#71747A] mr-14">游客姓名：</span><span class='text-[#333333]'>{{ currentUserRow.name
              }}</span>
          </div>

          <div class="mt-12 flex-row">
            <span class="text-[#71747A] mr-2 flex-none">出散团日期：</span>
            <span class='text-[#333333]'>{{ teamDate }}</span>
          </div>
          <!-- 日期 -->
          <div v-if="userInsuranceDetail" v-for="item in userInsuranceDetail" :key="item.id">
            <div class="mt-20  font-600 text-16 text-[#1E2226]">{{ item.date }}</div>
            <div class="mt-12 bg-[#F0F2F5] rounded-4  p-15">
              <div class="text-[#71747A] ">带团旅行社：</div>
              <div class="text-[#1E2226] font-bold mt-8 mb-8">{{ item.travelNames.join("\n") }}</div>
              <div class="my-16 divider" v-if="item.insuranceInfos"></div>
              <div class="text-[#71747A] mb-12">购买保险平台：</div>
              <template v-if="item.insuranceInfos">
                <div class="flex-col" v-for="cell in item.insuranceInfos" :key="cell.id">
                  <div class="my-5 flex gap-4">
                    <span class="bg-[#36B374] w-4 h-22"></span>
                    <span class="text-[#1E2226] leading-22 font-bold text-16 ">{{ cell.insurerName }}</span>
                  </div>
                  <div class="flex items-start mt-8 mb-8">
                    <span class="text-[#71747A] ">保险单号：</span>
                    <span class="text-[#333333] ">{{ cell.insuranceId }}</span>
                  </div>
                  <div class="flex items-start mt-8">
                    <span class="text-[#71747A] flex-none">保险覆盖时段：</span>
                    <div class="">
                      <span class="text-[#333333]">{{ cell.startDate }} 至 {{ cell.endDate }}</span>
                    </div>
                  </div>
                </div>
              </template>
              <div v-else>
                <div class="text-[#71747A]">没有数据</div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<style scoped>
@import url('https://bdc-images-1254950508.cos.ap-guangzhou.myqcloud.com/wxapp/font/font-DIN.css');

.bg-header {
  background: #e9faf1;
}

.highlight-number {
  font-size: 16PX;
  line-height: 22PX;
  color: rgb(var(--color-black-a));
}

.custom-table.o-table-wrapper {
  border-radius: 4px;
  border: 1px solid #fff;
}

.custom-table.o-table-wrapper:deep(.o-thead) {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.custom-table.o-table-wrapper:deep(.o-th) {
  text-align: left;
  background-image: linear-gradient(180deg, #f4fbf7, #e6f5ed);
  font-size: 14PX;
  line-height: 20PX;
  color: #1e2226;
  padding: 10px;
}

.custom-table.o-table-wrapper:deep(.o-th.o-th--fake) {
  padding: 0;
}

.custom-table.o-table-wrapper:deep(.o-td) {
  border-bottom: none;
  font-size: 14PX;
  line-height: 20PX;
  color: rgb(102 102 102 / var(--o-td-text-op, 1));
  padding: 12px 10px;
}

.custom-table.o-table-wrapper:deep(.o-td.o-td--fake) {
  padding: 0;
}

.custom-table.o-table-wrapper:deep(.o-tr:nth-child(2n) > .o-td) {
  background: #f7f8fa;
}

.custom-table.o-table-wrapper:deep(.o-th--sticky-left-shadow::after,
  .o-td--sticky-left-shadow::after) {
  width: 3px;
}
</style>

<style lang="less" scoped>
.custom-button {
  &.van-button--small {
    height: 32px;
    font-size: 14px;
    padding: 0 10px;
  }

  &:deep(.van-button__icon) {
    display: flex;
    align-items: center;
  }
}

.divider {
  width: 100%;
  height: 1px;
  background-color: #eee;
}
</style>
